module.exports = __webpack_public_path__ + "static/media/comments-alt-dollar.fa5e431e.svg";